<template>
  <div class="logout">
    <Title :iconBack="true"/>
    <div class="line-box"></div>
    <ul>
      <li  >版本号: <span>1.0.0</span></li>
      <li  @click="logOut">退出登录</li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.logout {
  font-size: 0.8rem;
  padding: 0 0.2rem;
  color: #666;
 
  ul{
      margin-top: .2rem;
      
      margin-left: -0.2rem;
      margin-right: -0.2rem;
      font-size: .5rem;
      li{
          border-top: 1px solid #f8f8f8;
          padding: .2rem;
      }
  }
}
</style>

<script>
import { MessageBox } from "mint-ui";
export default {
    methods:{
        logOut(){
            MessageBox.confirm('是否退出登录').then(action=>{
            	if(action === "confirm"){
                localStorage.removeItem('authorization')
								localStorage.removeItem('userId')
								localStorage.removeItem('account')
								localStorage.removeItem('mobile')
								localStorage.removeItem('origin')
								localStorage.removeItem('customerId')
								localStorage.removeItem("wx_openId")
								localStorage.removeItem("roleY")
								localStorage.removeItem("role")
								localStorage.removeItem("shopId")
								localStorage.removeItem("shopType")
								localStorage.removeItem("baserole")
								localStorage.setItem('isAuth',0)
                this.$router.push({name:'home'})
            	}
            },cancel=>{
            	
            })
        }
    }
}
</script>
<style scoped="scoped" lang="scss">
	.logout{
		padding:0;
		.line-box{
			width:100%;
			height:0.12rem;
			background-color: #EFEFF4;
		}
		ul{
			margin-top:0.2rem;
			li{
				font-size:16px;
				color:#000000;
				line-height:1rem;
				padding-left:0.6rem;
				border-top:none;
				border-bottom:1px solid #EFEFF4;
				span{
					font-size:16px;
				}
			}
		}
		
	}
</style>